<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Header -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-clients-header">
            <div class="card-header trainer-card-header">
              <div class="row align-items-center">
                <div class="col-sm-6">
                  <h4 class="card-title trainer-title">
                    <i class="nc-icon nc-user-run"></i>
                    Mis Clientes
                  </h4>
                  <p class="card-category trainer-subtitle">
                    Gestiona todos tus clientes y su progreso
                  </p>
                </div>
                <div class="col-sm-6 text-right">
                  <button class="btn btn-light trainer-btn-add-client" @click="showAddClientModal = true">
                    <i class="nc-icon nc-simple-add"></i>
                    Nuevo Cliente
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Estadísticas Rápidas -->
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-single-02 text-success"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Total Clientes</p>
                    <p class="card-title trainer-number">{{ clients.length }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-chart-pie-36 text-warning"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Activos</p>
                    <p class="card-title trainer-number">{{ activeClients }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-calendar-60 text-info"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Sesiones Hoy</p>
                    <p class="card-title trainer-number">8</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-satisfied text-primary"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Satisfacción</p>
                    <p class="card-title trainer-number">94%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Filtros y Búsqueda -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <input 
                      type="text" 
                      class="form-control" 
                      placeholder="Buscar cliente..."
                      v-model="searchQuery"
                    >
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <select class="form-control" v-model="statusFilter">
                      <option value="">Todos los estados</option>
                      <option value="activo">Activos</option>
                      <option value="inactivo">Inactivos</option>
                      <option value="suspendido">Suspendidos</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <select class="form-control" v-model="goalFilter">
                      <option value="">Todos los objetivos</option>
                      <option value="perder_peso">Perder Peso</option>
                      <option value="ganar_musculo">Ganar Músculo</option>
                      <option value="mejorar_condicion">Mejorar Condición</option>
                      <option value="rehabilitacion">Rehabilitación</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <button class="btn trainer-btn-primary w-100" @click="exportClients">
                    <i class="nc-icon nc-paper"></i> Exportar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Lista de Clientes -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Lista de Clientes ({{ filteredClients.length }})</h6>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table trainer-clients-table">
                  <thead>
                    <tr>
                      <th>Cliente</th>
                      <th>Objetivo</th>
                      <th>Progreso</th>
                      <th>Última Sesión</th>
                      <th>Próxima Sesión</th>
                      <th>Estado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="client in filteredClients" :key="client.id" class="trainer-client-row">
                      <td>
                        <div class="trainer-client-info">
                          <img :src="client.avatar" :alt="client.name" class="trainer-client-avatar">
                          <div>
                            <strong>{{ client.name }}</strong>
                            <br><small class="text-muted">{{ client.email }}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span class="badge trainer-goal-badge" :class="getGoalClass(client.goal)">
                          {{ getGoalLabel(client.goal) }}
                        </span>
                      </td>
                      <td>
                        <div class="trainer-progress">
                          <div class="progress">
                            <div 
                              class="progress-bar trainer-progress-bar" 
                              :style="{ width: client.progress + '%' }"
                            ></div>
                          </div>
                          <span class="trainer-progress-text">{{ client.progress }}%</span>
                        </div>
                      </td>
                      <td>{{ formatDate(client.lastSession) }}</td>
                      <td>
                        <span v-if="client.nextSession" :class="getNextSessionClass(client.nextSession)">
                          {{ formatDate(client.nextSession) }}
                        </span>
                        <span v-else class="text-muted">Sin programar</span>
                      </td>
                      <td>
                        <span class="badge trainer-status-badge" :class="getStatusClass(client.status)">
                          {{ getStatusLabel(client.status) }}
                        </span>
                      </td>
                      <td>
                        <div class="trainer-actions">
                          <button class="btn btn-sm btn-outline-primary" @click="viewClient(client)" title="Ver Perfil">
                            <i class="nc-icon nc-single-02"></i>
                          </button>
                          <button class="btn btn-sm btn-outline-success" @click="scheduleSession(client)" title="Programar Sesión">
                            <i class="nc-icon nc-calendar-60"></i>
                          </button>
                          <button class="btn btn-sm btn-outline-info" @click="sendMessage(client)" title="Enviar Mensaje">
                            <i class="nc-icon nc-chat-33"></i>
                          </button>
                          <button class="btn btn-sm btn-outline-warning" @click="viewProgress(client)" title="Ver Progreso">
                            <i class="nc-icon nc-chart-bar-32"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Actividad Reciente -->
      <div class="row">
        <div class="col-lg-6">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Actividad Reciente</h6>
            </div>
            <div class="card-body">
              <div class="trainer-activity-item" v-for="activity in recentActivity" :key="activity.id">
                <div class="trainer-activity-icon" :class="activity.type">
                  <i :class="activity.icon"></i>
                </div>
                <div class="trainer-activity-content">
                  <p class="trainer-activity-text">{{ activity.text }}</p>
                  <small class="trainer-activity-time">{{ activity.time }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-6">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Próximas Sesiones</h6>
            </div>
            <div class="card-body">
              <div class="trainer-session-item" v-for="session in upcomingSessions" :key="session.id">
                <div class="trainer-session-time">
                  <strong>{{ session.time }}</strong>
                  <br><small>{{ session.date }}</small>
                </div>
                <div class="trainer-session-client">
                  <img :src="session.client.avatar" :alt="session.client.name" class="trainer-session-avatar">
                  <div>
                    <strong>{{ session.client.name }}</strong>
                    <br><small>{{ session.type }}</small>
                  </div>
                </div>
                <div class="trainer-session-actions">
                  <button class="btn btn-sm btn-outline-primary">Iniciar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para Nuevo Cliente -->
    <div class="modal" v-if="showAddClientModal" @click="showAddClientModal = false">
      <div class="modal-dialog modal-lg" @click.stop>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Nuevo Cliente</h5>
            <button type="button" class="close" @click="showAddClientModal = false">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Nombre Completo</label>
                    <input type="text" class="form-control" placeholder="Nombre completo">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Email</label>
                    <input type="email" class="form-control" placeholder="Email">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Teléfono</label>
                    <input type="tel" class="form-control" placeholder="Teléfono">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Fecha de Nacimiento</label>
                    <input type="date" class="form-control">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Objetivo Principal</label>
                    <select class="form-control">
                      <option value="">Seleccionar objetivo</option>
                      <option value="perder_peso">Perder Peso</option>
                      <option value="ganar_musculo">Ganar Músculo</option>
                      <option value="mejorar_condicion">Mejorar Condición</option>
                      <option value="rehabilitacion">Rehabilitación</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Nivel de Experiencia</label>
                    <select class="form-control">
                      <option value="principiante">Principiante</option>
                      <option value="intermedio">Intermedio</option>
                      <option value="avanzado">Avanzado</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>Notas Médicas/Restricciones</label>
                <textarea class="form-control" rows="3" placeholder="Información médica relevante..."></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showAddClientModal = false">Cancelar</button>
            <button type="button" class="btn trainer-btn-primary" @click="addClient">Crear Cliente</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainerClients',
  data() {
    return {
      showAddClientModal: false,
      searchQuery: '',
      statusFilter: '',
      goalFilter: '',
      clients: [
        {
          id: 1,
          name: 'Ana Martínez',
          email: 'ana.martinez@email.com',
          avatar: '/static/img/faces/ayo-ogunseinde-2.jpg',
          goal: 'perder_peso',
          progress: 78,
          lastSession: '2024-01-15',
          nextSession: '2024-01-20',
          status: 'activo'
        },
        {
          id: 2,
          name: 'Carlos Ruiz',
          email: 'carlos.ruiz@email.com',
          avatar: '/static/img/faces/erik-lucatero-2.jpg',
          goal: 'ganar_musculo',
          progress: 65,
          lastSession: '2024-01-14',
          nextSession: '2024-01-19',
          status: 'activo'
        },
        {
          id: 3,
          name: 'María González',
          email: 'maria.gonzalez@email.com',
          avatar: '/static/img/faces/avatar.png',
          goal: 'mejorar_condicion',
          progress: 45,
          lastSession: '2024-01-10',
          nextSession: null,
          status: 'inactivo'
        },
        {
          id: 4,
          name: 'José López',
          email: 'jose.lopez@email.com',
          avatar: '/static/img/faces/erik-lucatero-2.jpg',
          goal: 'rehabilitacion',
          progress: 89,
          lastSession: '2024-01-16',
          nextSession: '2024-01-21',
          status: 'activo'
        }
      ],
      recentActivity: [
        {
          id: 1,
          type: 'session',
          icon: 'nc-icon nc-calendar-60',
          text: 'Sesión completada con Ana Martínez',
          time: 'Hace 2 horas'
        },
        {
          id: 2,
          type: 'message',
          icon: 'nc-icon nc-chat-33',
          text: 'Nuevo mensaje de Carlos Ruiz',
          time: 'Hace 4 horas'
        },
        {
          id: 3,
          type: 'progress',
          icon: 'nc-icon nc-chart-bar-32',
          text: 'José López completó su evaluación',
          time: 'Ayer'
        }
      ],
      upcomingSessions: [
        {
          id: 1,
          time: '09:00',
          date: 'Hoy',
          client: {
            name: 'Ana Martínez',
            avatar: '/static/img/faces/ayo-ogunseinde-2.jpg'
          },
          type: 'Entrenamiento Funcional'
        },
        {
          id: 2,
          time: '11:00',
          date: 'Hoy',
          client: {
            name: 'Carlos Ruiz',
            avatar: '/static/img/faces/erik-lucatero-2.jpg'
          },
          type: 'Fuerza'
        }
      ]
    }
  },
  computed: {
    activeClients() {
      return this.clients.filter(client => client.status === 'activo').length;
    },
    filteredClients() {
      let filtered = this.clients;
      
      if (this.searchQuery) {
        filtered = filtered.filter(client => 
          client.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          client.email.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }
      
      if (this.statusFilter) {
        filtered = filtered.filter(client => client.status === this.statusFilter);
      }
      
      if (this.goalFilter) {
        filtered = filtered.filter(client => client.goal === this.goalFilter);
      }
      
      return filtered;
    }
  },
  methods: {
    getGoalClass(goal) {
      const classes = {
        'perder_peso': 'badge-warning',
        'ganar_musculo': 'badge-success',
        'mejorar_condicion': 'badge-info',
        'rehabilitacion': 'badge-danger'
      };
      return classes[goal] || 'badge-secondary';
    },
    getGoalLabel(goal) {
      const labels = {
        'perder_peso': 'Perder Peso',
        'ganar_musculo': 'Ganar Músculo',
        'mejorar_condicion': 'Mejorar Condición',
        'rehabilitacion': 'Rehabilitación'
      };
      return labels[goal] || goal;
    },
    getStatusClass(status) {
      const classes = {
        'activo': 'badge-success',
        'inactivo': 'badge-warning',
        'suspendido': 'badge-danger'
      };
      return classes[status] || 'badge-secondary';
    },
    getStatusLabel(status) {
      const labels = {
        'activo': 'Activo',
        'inactivo': 'Inactivo',
        'suspendido': 'Suspendido'
      };
      return labels[status] || status;
    },
    getNextSessionClass(date) {
      // Lógica para determinar si la próxima sesión está próxima, atrasada, etc.
      return 'text-success';
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES');
    },
    viewClient(client) {
      this.$swal.fire({
        title: 'Perfil de Cliente',
        html: `
          <div style="text-align: left;">
            <p><strong>Nombre:</strong> ${client.name}</p>
            <p><strong>Email:</strong> ${client.email}</p>
            <p><strong>Objetivo:</strong> ${this.getGoalLabel(client.goal)}</p>
            <p><strong>Progreso:</strong> ${client.progress}%</p>
            <p><strong>Estado:</strong> ${this.getStatusLabel(client.status)}</p>
          </div>
        `,
        confirmButtonColor: '#9ACD32'
      });
    },
    scheduleSession(client) {
      this.$swal.fire({
        title: 'Programar Sesión',
        text: `Programar nueva sesión para ${client.name}`,
        confirmButtonColor: '#9ACD32'
      });
    },
    sendMessage(client) {
      this.$swal.fire({
        title: 'Enviar Mensaje',
        text: `Enviar mensaje a ${client.name}`,
        confirmButtonColor: '#9ACD32'
      });
    },
    viewProgress(client) {
      this.$swal.fire({
        title: 'Progreso de Cliente',
        text: `Ver progreso detallado de ${client.name}`,
        confirmButtonColor: '#9ACD32'
      });
    },
    addClient() {
      this.showAddClientModal = false;
      this.$swal.fire({
        title: 'Cliente Creado',
        text: 'El nuevo cliente ha sido agregado exitosamente',
        icon: 'success',
        confirmButtonColor: '#9ACD32'
      });
    },
    exportClients() {
      this.$swal.fire({
        title: 'Exportar Clientes',
        text: 'Funcionalidad de exportación en desarrollo',
        icon: 'info',
        confirmButtonColor: '#9ACD32'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  --trainer-primary: #9ACD32;
  --trainer-secondary: #7CB342;
  --trainer-accent: #8BC34A;
  --trainer-dark: #689F38;
  --trainer-light: #DCEDC8;
  --trainer-bg: #F1F8E9;
}

.trainer-clients-header {
  background: linear-gradient(135deg, var(--trainer-primary), var(--trainer-secondary));
  color: white;
  border: none;
  box-shadow: 0 4px 20px 0px rgba(154, 205, 50, 0.14), 0 7px 10px -5px rgba(154, 205, 50, 0.4);
  
  .trainer-card-header {
    background: transparent;
    border: none;
  }
  
  .trainer-title {
    color: white;
    font-weight: 500;
    margin-bottom: 5px;
    
    i {
      margin-right: 10px;
    }
  }
  
  .trainer-subtitle {
    color: rgba(255,255,255,0.8);
    margin: 0;
  }
  
  .trainer-btn-add-client {
    border: 2px solid rgba(255,255,255,0.3);
    color: white;
    
    &:hover {
      background: rgba(255,255,255,0.1);
      border-color: rgba(255,255,255,0.5);
    }
  }
}

.trainer-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  margin-bottom: 20px;
  
  .card-header {
    background: var(--trainer-bg);
    border-bottom: 1px solid #dee2e6;
    
    .card-title {
      color: var(--trainer-dark);
      font-weight: 600;
      margin: 0;
    }
  }
}

.trainer-stats-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 5px 25px 0 rgba(0,0,0,0.15);
    transform: translateY(-2px);
  }
  
  .trainer-number {
    font-size: 24px;
    font-weight: 700;
    color: var(--trainer-dark);
  }
}

.trainer-clients-table {
  .trainer-client-row {
    &:hover {
      background: var(--trainer-bg);
    }
  }
  
  .trainer-client-info {
    display: flex;
    align-items: center;
    
    .trainer-client-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 12px;
      object-fit: cover;
    }
  }
  
  .trainer-progress {
    display: flex;
    align-items: center;
    gap: 10px;
    
    .progress {
      flex: 1;
      height: 8px;
      background: #e9ecef;
      border-radius: 4px;
      
      .trainer-progress-bar {
        background: var(--trainer-primary);
        border-radius: 4px;
      }
    }
    
    .trainer-progress-text {
      font-size: 12px;
      font-weight: 600;
      color: var(--trainer-dark);
      min-width: 35px;
    }
  }
  
  .trainer-goal-badge {
    font-size: 11px;
    padding: 4px 8px;
  }
  
  .trainer-status-badge {
    font-size: 11px;
    padding: 4px 8px;
  }
  
  .trainer-actions {
    display: flex;
    gap: 5px;
    
    .btn {
      padding: 4px 8px;
      font-size: 12px;
    }
  }
}

.trainer-activity-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  
  .trainer-activity-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    
    &.session {
      background: rgba(154, 205, 50, 0.2);
      color: var(--trainer-primary);
    }
    
    &.message {
      background: rgba(52, 144, 220, 0.2);
      color: #3490dc;
    }
    
    &.progress {
      background: rgba(255, 193, 7, 0.2);
      color: #ffc107;
    }
  }
  
  .trainer-activity-content {
    flex: 1;
    
    .trainer-activity-text {
      margin: 0;
      font-size: 14px;
      color: #333;
    }
    
    .trainer-activity-time {
      color: #666;
      font-size: 12px;
    }
  }
}

.trainer-session-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
  
  .trainer-session-time {
    margin-right: 15px;
    text-align: center;
    min-width: 80px;
    
    strong {
      color: var(--trainer-primary);
      font-size: 16px;
    }
    
    small {
      color: #666;
    }
  }
  
  .trainer-session-client {
    display: flex;
    align-items: center;
    flex: 1;
    
    .trainer-session-avatar {
      width: 35px;
      height: 35px;
      border-radius: 50%;
      margin-right: 10px;
      object-fit: cover;
    }
  }
  
  .trainer-session-actions {
    .btn {
      font-size: 12px;
      padding: 4px 12px;
    }
  }
}

.trainer-btn-primary {
  background: var(--trainer-primary);
  border-color: var(--trainer-primary);
  color: white;
  
  &:hover {
    background: var(--trainer-secondary);
    border-color: var(--trainer-secondary);
  }
}

.form-control {
  border: 2px solid #e9ecef;
  border-radius: 6px;
  
  &:focus {
    border-color: var(--trainer-primary);
    box-shadow: 0 0 0 0.2rem rgba(154, 205, 50, 0.25);
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  
  .modal-dialog {
    background: white;
    border-radius: 8px;
    max-width: 90%;
    max-height: 90%;
    overflow-y: auto;
  }
  
  .modal-header {
    padding: 20px;
    border-bottom: 1px solid #dee2e6;
    
    .modal-title {
      color: var(--trainer-dark);
      font-weight: 600;
    }
    
    .close {
      background: none;
      border: none;
      font-size: 24px;
      line-height: 1;
      color: #999;
      cursor: pointer;
    }
  }
  
  .modal-body {
    padding: 20px;
  }
  
  .modal-footer {
    padding: 20px;
    border-top: 1px solid #dee2e6;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>